import { useStore } from '@nanostores/react'
import { atom } from 'nanostores'

const $isOpen = atom(false)

const useInviteModal = () => useStore($isOpen)
const openInvite = () => $isOpen.set(true)
const closeInvite = () => $isOpen.set(false)

export { closeInvite, openInvite, useInviteModal }
